import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from '../../components/feature/HeroSection';
import TrustBar from '../../components/feature/TrustBar';
import ServicesGrid from '../../components/feature/ServicesGrid';
import AIBlock from '../../components/feature/AIBlock';
import ProcessTimeline from '../../components/feature/ProcessTimeline';
import WhyChooseUs from '../../components/feature/WhyChooseUs';
import ServiceAreaMap from '../../components/feature/ServiceAreaMap';
import TestimonialsSection from '../../components/feature/TestimonialsSection';
import FAQAccordion from '../../components/feature/FAQAccordion';
import FinalCTASection from '../../components/feature/FinalCTASection';

const heroData = {
  eyebrow: 'Our Story — Jeffersonville, Indiana',
  headline: 'A Family Committed to',
  headlineAccent: 'Clean Energy.',
  subheadline:
    'Since 2015, Star Solar Specialists has been a family-owned solar company rooted in the Kentuckiana community. We bring big-company expertise with small-business care to every installation.',
  primaryCTA: {
    label: 'Meet the Team',
    href: 'https://starsolarspecialists.com/our-team/',
    external: true,
  },
  secondaryCTA: {
    label: 'Get a Free Estimate',
    href: '#estimate',
  },
  backgroundImage:
    'https://starsolarspecialists.com/wp-content/uploads/2020/04/Star-Solar_HGRS1-e1588107192659.jpg',
};

const valuesCards = [
  {
    title: 'Our Mission',
    description:
      'To make clean, affordable solar energy accessible to every homeowner, business, and nonprofit in Southern Indiana and North Central Kentucky.',
    image:
      'https://starsolarspecialists.com/wp-content/uploads/2021/08/67-print-4900-Dunbar-Valley-rd-65-scaled-e1629667416567.jpg',
    href: '/about',
    badge: 'Since 2015',
  },
  {
    title: 'Residential Expertise',
    description:
      'We\'ve designed and installed solar systems for hundreds of Kentuckiana homes, from small family residences to large estates.',
    image:
      'https://starsolarspecialists.com/wp-content/uploads/2021/08/67-print-4900-Dunbar-Valley-rd-65-scaled-e1629667416567.jpg',
    href: '/services',
  },
  {
    title: 'Commercial Excellence',
    description:
      'Our commercial division has installed systems for businesses of all sizes — office buildings, warehouses, farms, and nonprofits.',
    image:
      'https://starsolarspecialists.com/wp-content/uploads/2021/07/54-print-4403-Hamburg-Pike-53-scaled.jpg',
    href: '/services',
  },
];

const aiData = {
  eyebrow: 'Who We Are',
  headline: 'Kentuckiana\'s Original Local Solar Specialists',
  description:
    'Star Solar Specialists is a family-owned and operated solar power installation company based in Jeffersonville, Indiana. We are professionally licensed and proud to provide affordable solar power options to Southern Indiana and North Central Kentucky. We are a rare team of highly skilled professionals dedicated to bringing affordable solar power to Kentuckiana since 2015.',
  pillars: [
    {
      icon: 'ri-family-line',
      title: 'Family Owned & Operated',
      description: 'Founded and run by a local Kentuckiana family — we treat every customer as a neighbor.',
    },
    {
      icon: 'ri-map-pin-line',
      title: 'Locally Based',
      description: 'Our office is in Jeffersonville, IN — we understand local utilities, weather, and permitting.',
    },
    {
      icon: 'ri-verified-badge-line',
      title: 'Dual-State Licensed',
      description: 'Professionally licensed to install solar power in both Indiana and Kentucky.',
    },
    {
      icon: 'ri-history-line',
      title: 'Proven Track Record',
      description: 'A decade of installations across Kentuckiana — homes, businesses, and nonprofits.',
    },
  ],
};

const companySteps = [
  {
    number: '2015',
    title: 'Founded in Jeffersonville',
    description: 'Star Solar Specialists was established with a mission to bring affordable solar to Southern Indiana and North Central Kentucky.',
  },
  {
    number: '2017',
    title: 'Kentucky Licensing',
    description: 'Expanded our licensing to cover all of North Central Kentucky, becoming one of the few dual-state certified solar installers in Kentuckiana.',
  },
  {
    number: '2020',
    title: 'Commercial Expansion',
    description: 'Launched our dedicated commercial solar division, installing systems for businesses and nonprofits across the region.',
  },
  {
    number: 'Today',
    title: 'Kentuckiana\'s Trusted Installer',
    description: 'Hundreds of satisfied customers, five-star ratings, and a team of expert installers dedicated to your solar success.',
  },
];

const aboutFaqs = [
  {
    question: 'Is Star Solar Specialists a local company?',
    answer: 'Yes. Star Solar Specialists is a family-owned, locally operated company headquartered at 509 Ohio Avenue in Jeffersonville, Indiana. We are not a franchise or national chain — we are your neighbors, fully invested in the Kentuckiana community.',
  },
  {
    question: 'How long has Star Solar Specialists been in business?',
    answer: 'Star Solar Specialists was founded in 2015 and has been serving Southern Indiana and North Central Kentucky ever since. With nearly a decade of experience, we are one of the most established solar installation companies in the Kentuckiana region.',
  },
  {
    question: 'Is Star Solar Specialists licensed in both Indiana and Kentucky?',
    answer: 'Yes. We are professionally licensed to install solar power systems in both Indiana and Kentucky, making us uniquely qualified to serve the entire Kentuckiana region. We carry all required certifications and insurance.',
  },
];

const AboutPage = () => (
  <main>
    <Navbar />
    <HeroSection data={heroData} />
    <TrustBar />
    <ServicesGrid
      eyebrow="Our Story"
      headline="A Decade of Solar Excellence in Kentuckiana"
      cards={valuesCards}
    />
    <AIBlock {...aiData} />
    <ProcessTimeline
      eyebrow="Our History"
      headline="A Decade of Growth in Kentuckiana"
      steps={companySteps}
    />
    <WhyChooseUs
      eyebrow="What Sets Us Apart"
      headline="The Values Behind Every Installation"
    />
    <ServiceAreaMap
      eyebrow="Our Community"
      headline="Rooted in Kentuckiana"
    />
    <TestimonialsSection
      eyebrow="Our Reputation"
      headline="What Kentuckiana Says About Us"
    />
    <FAQAccordion
      eyebrow="About Us"
      headline="Questions About Star Solar Specialists"
      items={aboutFaqs}
    />
    <FinalCTASection
      headline="Meet Your Local Solar Specialists"
      subheadline="We'd love to learn about your property and show you what solar can do for your home or business. Free consultation, zero pressure."
      primaryCTA="Schedule a Consultation"
    />
    <Footer />
  </main>
);

export default AboutPage;
